import React from 'react';
import { Text, Colors } from 'library';
import { Provider } from 'models';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import { Grid } from '@material-ui/core';
import { useModalsContext } from 'ModalsContext';
import { track } from 'shared';
import usePublicSessionTracking, { PublicSessionEventType } from 'parent-portal/shared/PublicSessionTracking';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PostAJobToBook({ provider }: { provider: Provider }) {
    const { openJobForm } = useModalsContext();
    const { trackSession } = usePublicSessionTracking('Family Api');

    function onPostAJobClick() {
        const trackMessage = 'Post a Job to Book click';
        trackSession('CLICK', `Provider Profile: ${trackMessage}`, PublicSessionEventType.User);
        track('Post a Job to Book click');
        let presets = {
            invitedProvider: provider,
        };
        openJobForm(trackMessage, presets);
    }

    return (
        <Grid
            onClick={onPostAJobClick}
            style={{
                backgroundColor: Colors.lightGreen,
                marginTop: 20,
                paddingTop: 10,
                paddingBottom: 10,
                borderRadius: 20,
                maxWidth: 320,
            }}
        >
            <Grid container item direction="row" style={{ alignContent: 'center', marginLeft: 20 }}>
                <Grid
                    item
                    xs={2}
                    style={{
                        alignSelf: 'center',
                    }}
                >
                    <FontAwesomeIcon icon={faCalendarPlus} fontSize={40} color={Colors.darkNavy} />
                </Grid>
                <Grid container item direction="column" xs={9} style={{ marginRight: 8 }}>
                    <Grid item>
                        <Text variant="h2" bold textStyle={{ textAlign: 'left' }}>
                            Want to hire {provider.user.first_name}?
                        </Text>
                    </Grid>
                    <Grid container item direction="row">
                        <Grid item>
                            <Text variant="body2" textStyle={{ textAlign: 'left' }}>
                                <Text
                                    variant="body2"
                                    textStyle={{ display: 'inline', textDecoration: 'underline', cursor: 'pointer' }}
                                >
                                    Post a job
                                </Text>{' '}
                                and we'll send it to them!
                            </Text>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1} />
            </Grid>
        </Grid>
    );
}
